import React from "react";
import { useTranslation } from "react-i18next";
import {
  useDisableResource,
  useResourceRetrieval,
} from "@planzone/view-models";
import { ProjectResource, Resource } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { InfoResource } from "./infoResource";
import styles from "./styles.scss";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";

function ResourceDeactivation({ planzoneResource, cancel }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isResourceRetrievalPending,
    isRequestSuccess,
    isRequestFailure,
    resource,
    retrieveResource,
  } = useResourceRetrieval(planzoneResource.uuid);
  const { isRequestPending, disableResource } =
    useDisableResource(planzoneResource);
  const [formData, setFormData] = React.useState<Resource>(planzoneResource);

  React.useEffect(() => {
    !isResourceRetrievalPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResource(planzoneResource.uuid);
  }, [planzoneResource.uuid]);

  React.useEffect(() => {
    setFormData(planzoneResource);
  }, [planzoneResource]);

  return (
    <Modal header={t("disableResource.title")} close={cancel}>
      <Safeguard useCases={[UseCases.disableResource]}>
        {({ canDisableResource }) => (
          <div className={styles.projectResourceDeactivation}>
            <div className={styles.body}>
              <div className={styles.group}>
                <p className={styles.warning}>{t("disableResource.warning")}</p>
              </div>
              <InfoResource
                resource={isRequestSuccess ? resource : planzoneResource}
              />
            </div>
            {canDisableResource && (
              <div className={styles.footer}>
                <Button type="cancel" press={cancel}>
                  {t("disableResource.cancel")}
                </Button>
                <Button
                  type={"submit"}
                  status={isRequestPending ? "pending" : "none"}
                  isDisabled={isRequestPending}
                  press={() =>
                    disableResource({
                      resource,
                      nextResource: { ...formData, deactivated: true },
                    })
                  }
                >
                  {t("disableResource.save")}
                </Button>
              </div>
            )}
          </div>
        )}
      </Safeguard>
    </Modal>
  );
}

export { ResourceDeactivation };
